import React from "react";
import Icon from "@ant-design/icons";
import { ArrowDownSvg, SearchSvg } from "../../assets/icons";

export const ArrowDownIcon = (props) => <Icon component={ArrowDownSvg} {...props} />;
export const SearchIcon = (props) => <Icon component={SearchSvg} {...props} />;
